/* Global state */

import Settings from "./settings";
import HTTP from "./http.service";
import User from "./user";

import Errors from "./errors.service";

import Translations from "./translation";
import Storage from "./storage.service";

var Globals = {

	vat: 0,
	assigned_number: null,
	selected_plan: null,
	delivery_address: null,
	predefinedPlans: null,
	defaultSeletedPlan: null,
	address_success: false,

	tooltips_order: ["data rollover", "local plan", "data plan", "international plan", "unlimited local"],
	
	amex_mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, ],
	card_mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, ],
	mask_emirates_id: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, ],
	app_link: "",
	plan_circles_order: ["DATA", "VOICE-LCL", "VOICE-INT"],
	types: ["VOICE-LCL", "DATA", "VOICE-INT"],
	types_human_map: {
		"VOICE-LCL": "local",
		DATA: "data",
		"VOICE-INT": "international",
	},
	types_human_map_short: {
		"VOICE-LCL": "local",
		DATA: "data",
		"VOICE-INT": "int",
	},
	types_human_caps: {
		"VOICE-LCL": "Local",
		DATA: "Data",
		"VOICE-INT": "International",
	},
	types_new_order: ["DATA", "VOICE-LCL", "VOICE-INT"],

	formats: {
		// email:/^\w(.\w*)+@[a-zA-Z_]+?\.[a-zA-Z]{2,5}$/,
		email: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		cardnumber: /^[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}|^3[47][0-9 ]{5,}$/,

		cards: {
			amex: /^(37|34)[0-9 ]{0,}$/,
			visa: /^4/,
			mastercard: /^5[1-5][0-9]{14,}$/,
			// mastercard: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/
			
		},

		limits: {
			card_max: /^.{15}|.{16}$/,
			cvv_max: /^[0-9]{3}$/,
			card_date_max: /^.{5}$/,
			card_general_max: /^.{16}$/,
			card_amex_max: /^.{15}$/,
		},

		cardcvvInitial: /^([0-9]{0,3})$/,
		cardcvvInitialAmex: /^([0-9]{0,4})$/,

		cardcvv: /^([0-9]{3,4})$/,
		cardcvv4: /^([0-9]{4})$/,
		expiry: /^[0-9]{1,2}\/[0-9]{2}$/,

		digits_slashes: /^[0-9]{0,2}\/{0,1}[0-9]{0,2}$/,
		emirates_id: /^[0-9]{15}$/,

		phonemax: /^.{0,12}$/,

		phonenumber:  /^(\+\d{0,14}|[0-9]{1,12})$/,
		uaephonenumber: /^[0-9]{10,12}$/,
		phonefragment: /^[0-9]{1,7}$/,
		phonefragmentmax: /^[0-9]{0,7}$/,
		text_only: /^([^0-9]*)$/,
		card_text_only: /^[a-zA-Z ]*$/,
		digits_only: /^([0-9]*)$/,
		rating_feedback: /^[^<>{}()_*^#]{0,50}$/,
		card_number_mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, ],
		minLength: /(.{8,})/,
		oneDigit: /(?=.*?[0-9])/,
		oneUpperCaseCharacter: /(?=.*[A-Z])/,
	},

};

Globals.setError = (type, code = null) => {
	Storage.set("error", { type: type, code: code });
};

Globals.handleError = (error, callee = "") => {
	if (Settings.debug_errors) console.log("Globals.handleError from ", callee, error);

	let code = Errors.getErrorCode(error);
	let type = Errors.getErrorType(code);

	switch (code) {
		case -27: // User has been logged out
		case -7104: // Session and device-id mismatch
		case -7043: // Session and device-id mismatch
		case -199:
			User.errorLogout();
			break;

		default:
			// code...
			Globals.setError(type, code);
			break;
	}
};

Globals.checkCode = (code, email) => {
	let config = {
		method: "post",
		url: "/securitymanagement/validate_verification_code",
		data: {
			code: code,
			email: email,
		},
	};
	return HTTP(config);
};

Translations.getTranslationsObsrv().subscribe((data) => {
	if (data) {
		let strings = Translations["keys"][Translations.activeLang];

		Globals["credit_card_form_messages"] = {
			REQUIRED_FIELD: strings["MESSAGES_ERROR_REQUIRED_FIELD"],
			WRONG_CREDIT_CARD_LUHN: strings["MESSAGES_ERROR_WRONG_CREDIT_CARD_LUHN"],
			WRONG_DATE: strings["MESSAGES_ERROR_WRONG_DATE"],
			WRONG_INPUT: strings["MESSAGES_ERROR_WRONG_INPUT"],
			WRONG_NAME: strings["MESSAGES_ERROR_WRONG_NAME"],
		};
		//ctas: ['change_card', 'retry_payment', 'start_chat', 'ok_clear_error', 'ok_clear_error_redirect']
		Globals["messages"] = {
			error_general: {
				title: strings["MESSAGES_ERROR_GENERAL_TITLE"],
				button_text: strings["MESSAGES_ERROR_GENERAL_BUTTON"],
				text: strings["MESSAGES_ERROR_GENERAL_TEXT"],
				key: "error_general",
			},
			error_fatal: {
				title: strings["MESSAGES_ERROR_GENERAL_TITLE"],
				text: strings["MESSAGES_ERROR_GENERAL_TEXT"],
				key: "error_fatal",
			},
			number_already_booked: {
				title: strings["MESSAGES_NUMBER_ALREADY_BOOKED_TITLE"],
				button_text: strings["MESSAGES_NUMBER_ALREADY_BOOKED_BUTTON"],
				text: strings["MESSAGES_NUMBER_ALREADY_BOOKED_TEXT"],
				key: "number_already_booked",
				ctas: ["ok_clear_error_get_status"],
			},
			// error_code_expired: {
			// 	title: strings["MESSAGES_ERROR_CODE_EXPIRED_TITLE"],
			// 	button_text: strings["MESSAGES_ERROR_CODE_EXPIRED_BUTTON"],
			// 	text: strings["MESSAGES_ERROR_CODE_EXPIRED_TEXT"],
			// 	key: "error_code_expired"
			// },
			// error_code_general: {
			// 	title: strings["MESSAGES_ERROR_CODE_GENERAL_TITLE"],
			// 	button_text: strings["MESSAGES_ERROR_CODE_GENERAL_BUTTON"],
			// 	text: strings["MESSAGES_ERROR_CODE_GENERAL_TEXT"],
			// 	key: "error_code_general"
			// },
			error_code_expired_simple: {
				title: strings["MESSAGES_ERROR_CODE_EXPIRED_TITLE"],
				button_text: "",
				text: strings["MESSAGES_ERROR_CODE_EXPIRED_TEXT"],
				key: "error_code_expired_simple",
			},

			login_credentials_error: {
				title: strings["MESSAGES_ERROR_WRONG_EMAIL_OR_PASSWORD_TEXT"],
				button_text: "",
				text: "",
				key: "login_credentials_error",
			},

			payment_error_failed: {
				title: strings["MESSAGES_PAYMENT_ERROR_FAILED_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_FAILED_TEXT"],
				key: "payment_error_failed",
				ctas: ["change_card"],
			},
			payment_error_transaction_failed: {
				title: strings["MESSAGES_PAYMENT_ERROR_TRANSACTION_FAILED_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_TRANSACTION_FAILED_TEXT"],
				key: "payment_error_transaction_failed",
				ctas: ["change_card"],
			},
			payment_error_incorrect_details: {
				title: strings["MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TEXT"],
				key: "payment_error_incorrect_details",
				ctas: ["retry_payment"],
			},
			payment_error_incorrect_details_temp_issue: {
				title: strings["MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TEMP_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_INCORRECT_DETAILS_TEMP_TEXT"],
				key: "payment_error_incorrect_details_temp_issue",
				ctas: ["change_card", "retry_payment"],
			},
			payment_error_incorrect_cvv: {
				title: strings["MESSAGES_PAYMENT_ERROR_INCORRECT_CVV_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_INCORRECT_CVV_TEXT"],
				key: "payment_error_incorrect_cvv",
				ctas: ["change_card", "retry_payment"],
			},
			payment_error_transaction_declined: {
				title: strings["MESSAGES_PAYMENT_ERROR_TRANSACTION_DECLINED_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_TRANSACTION_DECLINED_TEXT"],
				key: "payment_error_transaction_declined",
				ctas: ["change_card"],
			},
			payment_error_insufficient: {
				title: strings["MESSAGES_PAYMENT_ERROR_INSUFFICIENT_FUNDS_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_INSUFFICIENT_FUNDS_TEXT"],
				key: "payment_error_insufficient",
				ctas: ["change_card", "retry_payment"],
			},
			payment_error_fraud: {
				title: strings["MESSAGES_PAYMENT_ERROR_FRAUD_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_FRAUD_TEXT"],
				key: "payment_error_fraud",
				ctas: ["change_card"],
			},
			payment_error_general: {
				title: strings["MESSAGES_PAYMENT_ERROR_GENERAL_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_GENERAL_TEXT"],
				key: "payment_error_general",
				ctas: ["change_card"],
			},

			non_eligible_card: {
				title: "non_eligible_card",
				text: strings["MESSAGES_PAYMENT_ERROR_GENERAL_TEXT"],
				key: "payment_error_general",
				ctas: ["change_card"],
			},

			non_recurring_card: {
				title: "non_recurring_card",
				text: strings["MESSAGES_PAYMENT_ERROR_GENERAL_TEXT"],
				key: "payment_error_general",
				ctas: ["change_card", "continue_payment"],
			},

			spotii_error: {
				title: strings["MESSAGES_PAYMENT_ERROR_SPOTII_TITLE"],
				text: strings["MESSAGES_PAYMENT_ERROR_SPOTII_TEXT"],
				key: "spotii_error",
				ctas: ["ok_clear_error_get_status"],
			},
			installment_max_sim: {
				title: strings["INSTALMENTS_ID_UPLOAD_FAIL_MAX_SIM"],
				text: strings['INSTALMENTS_ID_UPLOAD_FAIL_MAX_SIM_DESC'],
				key: "installment_max_sim",
				ctas: ["ok_clear_error_get_status"],
			},

			// payment_error_declined: {
			// 	title: strings["MESSAGES_PAYMENT_ERROR_DECLINED_TITLE"],
			// 	button_text: strings["MESSAGES_PAYMENT_ERROR_DECLINED_BUTTON"],
			// 	text: strings["MESSAGES_PAYMENT_ERROR_DECLINED_TEXT"],
			// 	key: "payment_error_declined"
			// },

			// code_resent: {
			// 	title: strings["MESSAGES_CODE_RESENT_TITLE"],
			// 	button_text: strings["MESSAGES_CODE_RESENT_BUTTON"],
			// 	text: strings["MESSAGES_CODE_RESENT_TEXT"],
			// 	key: "code_resent"
			// },
			// sms_sent: {
			// 	title: strings["MESSAGES_SMS_SENT_TITLE"],
			// 	button_text: strings["MESSAGES_SMS_SENT_BUTTON"],
			// 	text: strings["MESSAGES_SMS_SENT_TEXT"],
			// 	key: "sms_sent"
			// },
			captcha_error: {
				title: strings["MESSAGES_CAPTCHA_ERROR_TITLE"],
				button_text: strings["MESSAGES_CAPTCHA_ERROR_BUTTON"],
				text: strings["MESSAGES_CAPTCHA_ERROR_TEXT"],
				key: "captcha_error",
			},
			nonce_error: {
				title: strings["MESSAGES_NONCE_ERROR_TITLE"],
				button_text: strings["MESSAGES_NONCE_ERROR_BUTTON"],
				text: strings["MESSAGES_NONCE_ERROR_TEXT"],
				key: "nonce_error",
			},
			// sms_error: {
			// 	title: strings["MESSAGES_SMS_ERROR_TITLE"],
			// 	button_text: strings["MESSAGES_SMS_ERROR_BUTTON"],
			// 	text: strings["MESSAGES_SMS_ERROR_TEXT"],
			// 	key: "sms_error"
			// },
			number_expired: {
				title: strings["MESSAGES_NUMBER_EXPIRED_TITLE"],
				button_text: strings["MESSAGES_NUMBER_EXPIRED_BUTTON"],
				text: strings["MESSAGES_NUMBER_EXPIRED_TEXT"],
				key: "number_expired",
				ctas: ["ok_clear_error_get_status"],
			},
			password_already_set: {
				title: strings["MESSAGES_PASSWORD_ALREADY_SET_TITLE"],
				button_text: strings["MESSAGES_PASSWORD_ALREADY_SET_BUTTON"],
				text: strings["MESSAGES_PASSWORD_ALREADY_SET_TEXT"],
				key: "password_already_set",
			},
			number_not_activated: {
				title: strings["MESSAGES_NUMBER_NOT_ACTIVATED_TITLE"],
				button_text: strings["MESSAGES_NUMBER_NOT_ACTIVATED_BUTTON"],
				text: strings["MESSAGES_NUMBER_NOT_ACTIVATED_TEXT"],
				key: "number_not_activated",
				ctas: ["reset_mnp"],
			},
			number_in_transfer: {
				title: strings["MESSAGES_NUMBER_IN_TRANSFER_TITLE"],
				button_text: strings["MESSAGES_NUMBER_IN_TRANSFER_BUTTON"],
				text: strings["MESSAGES_NUMBER_IN_TRANSFER_TEXT"],
				key: "number_not_activated",
				show_in_modal: true,
				ctas: ["reset_mnp"],
			},
			wrong_operator: {
				title: strings["MESSAGES_WRONG_OPERATOR_TITLE"],
				button_text: strings["MESSAGES_WRONG_OPERATOR_BUTTON"],
				text: strings["MESSAGES_WRONG_OPERATOR_TEXT"],
				key: "wrong_operator",
				show_in_modal: true,
				ctas: ["reset_mnp"],
			},
			saving_plan_error: {
				title: strings['MESSAGES_SAVING_PLAN_ERROR_TITLE'],
				button_text: strings['MESSAGES_SAVING_PLAN_ERROR_BTN'],
				text: strings['MESSAGES_SAVING_PLAN_ERROR_TEXT'],
				key: "saving_plan_error",
				show_in_modal: true,
				ctas: ["reset_flow"],
			},
			max_sims_reached : {
				button_text: 'More Info',
				button2_text: 'close',
				text: strings["MOI_ERROR_MAX_SIMS_REACHED"],
				key: 'max_sims_reached',
				show_in_modal: false,
				ctas: ["max_sims_redirect","redirect_to_activation_method"]
			},
			under_age_sim_activation : {
				title: 'Oh no!',
				button_text: 'retry',
				text: strings["MOI_ERROR_UNDER_AGE"],
				key: 'under_age_sim_activation',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			},
			black_listed_sim_activation : {
				title: 'Oh no!',
				button_text: 'Message Us',
				button2_text: 'Close',
				text: strings["MOI_ERROR_BLACKLIST"],
				key: 'black_listed_sim_activation',
				show_in_modal: false,
				ctas: ["redirect_to_app_chat","redirect_to_activation_method"]
			},
			retry_moi_scan : {
				title: 'Uh-oh! Something’s gone wrong.',
				button_text: 'retry',
				text: strings["MOI_ERROR_RETRY_SCAN"],
				key: 'retry_moi_scan',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			},
			moi_api_failure : {
				title: 'Uh-oh! Something’s gone wrong.',
				button_text: 'retry',
				text: strings["Try giving it another go!"],
				key: 'moi_api_failure',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			},
			moi_subscriberid_mismatch: {
				title: 'Oh no!',
				button_text: 'retry',
				text: strings["MOI_ERROR_SUBSCRIBER_ID_MISMATCH"],
				key: 'moi_subscriberid_mismatch',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			},
			residents_not_allowed_for_passport_moi: {
				title: strings["MOI_ERROR_RESIDENT_NOT_ALLOWED_TITLE"],
				button_text: 'Continue',
				text: strings["MOI_ERROR_RESIDENT_NOT_ALLOWED_MSG"],
				key: 'residents_not_allowed_for_passport_moi',
				show_in_modal: false,
				ctas: ["redirect_to_id_check"]
			},
			account_with_terminated_number: {
				title: strings["ACCOUNT_WITH_TERMINATED_EMAIL_ERROR_TITLE"],
				button_text: 'OK',
				text: strings["ACCOUNT_WITH_TERMINATED_EMAIL_ERROR_MSG"],
				key: 'account_with_terminated_number',
				show_in_modal: false,
				ctas: ["ok_clear_error"]
			},
			moi_error_residency_exists: {
				title: strings["MOI_ERROR_RESIDENCY_EXISTS_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_RESIDENCY_EXISTS_MSG"],
				key: 'moi_error_residency_exists',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_expired_immigration_record: {
				title: strings["MOI_ERROR_EXPIRED_IMMIGRATION_RECORD_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_EXPIRED_IMMIGRATION_RECORD_MSG"],
				key: 'moi_error_expired_immigration_record',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_invalid_immigration_record: {
				title: strings["MOI_ERROR_INVALID_IMMIGRATION_RECORD_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_INVALID_IMMIGRATION_RECORD_MSG"],
				key: 'moi_error_invalid_immigration_record',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_missmatched_person_identifier_expiry: {
				title: strings["MOI_ERROR_MISSMATCHED_PERSON_IDENTIFIER_EXPIRY_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_MISSMATCHED_PERSON_IDENTIFIER_EXPIRY_MSG"],
				key: 'moi_error_missmatched_person_identifier_expiry',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_expired_person_identifier: {
				title: strings["MOI_ERROR_EXPIRED_PERSON_IDENTIFIER_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_EXPIRED_PERSON_IDENTIFIER_MSG"],
				key: 'moi_error_expired_person_identifier',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_uncorrelated_person_identifiers: {
				title: strings["MOI_ERROR_UNCORRELATED_PERSON_IDENTIFIERS_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_UNCORRELATED_PERSON_IDENTIFIERS_MSG"],
				key: 'moi_error_uncorrelated_person_identifiers',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_no_match: {
				title: strings["MOI_ERROR_NO_MATCH_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_NO_MATCH_MSG"],
				key: 'moi_error_no_match',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_no_trusted_database_record_found: {
				title: strings["MOI_ERROR_NO_TRUSTED_DATABASE_RECORD_FOUND_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_NO_TRUSTED_DATABASE_RECORD_FOUND_MSG"],
				key: 'moi_error_no_trusted_database_record_found',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_face_prints_appear_to_be_of_multiple_persons: {
				title: strings["MOI_ERROR_FACE_PRINTS_APPEAR_TO_BE_OF_MULTIPLE_PERSONS_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_FACE_PRINTS_APPEAR_TO_BE_OF_MULTIPLE_PERSONS_MSG"],
				key: 'moi_error_face_prints_appear_to_be_of_multiple_persons',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_no_trusted_person_identifier_found: {
				title: strings["MOI_ERROR_NO_TRUSTED_PERSON_IDENTIFIER_FOUND_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_NO_TRUSTED_PERSON_IDENTIFIER_FOUND_MSG"],
				key: 'moi_error_no_trusted_person_identifier_found',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_invalid_id_details: {
				title: strings["MOI_ERROR_INVALID_ID_DETAILS_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_INVALID_ID_DETAILS_MSG"],
				key: 'moi_error_invalid_id_details',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_expired_date: {
				title: strings["MOI_ERROR_EXPIRED_DATE_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_EXPIRED_DATE_MSG"],
				key: 'moi_error_expired_date',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_mismatched_date_of_birth: {
				title: strings["MOI_ERROR_MISMATCHED_DATE_OF_BIRTH_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_MISMATCHED_DATE_OF_BIRTH_MSG"],
				key: 'moi_error_mismatched_date_of_birth',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_mismatched_gender: {
				title: strings["MOI_ERROR_MISMATCHED_GENDER_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_MISMATCHED_GENDER_MSG"],
				key: 'moi_error_mismatched_gender',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_unsupported_image_format: {
				title: strings["MOI_ERROR_UNSUPPORTED_IMAGE_FORMAT_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_UNSUPPORTED_IMAGE_FORMAT_MSG"],
				key: 'moi_error_unsupported_image_format',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_unsuitable_portrait_image: {
				title: strings["MOI_ERROR_UNSUITABLE_PORTRAIT_IMAGE_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_UNSUITABLE_PORTRAIT_IMAGE_MSG"],
				key: 'moi_error_unsuitable_portrait_image',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_image_too_large: {
				title: strings["MOI_ERROR_IMAGE_TOO_LARGE_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_IMAGE_TOO_LARGE_MSG"],
				key: 'moi_error_image_too_large',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_mismatched_hash: {
				title: strings["MOI_ERROR_MISMATCHED_HASH_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_MISMATCHED_HASH_MSG"],
				key: 'moi_error_mismatched_hash',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			  },
			  moi_error_unsupported_tag: {
				title: strings["MOI_ERROR_UNSUPPORTED_TAG_TITLE"],
				button_text: 'RETRY',
				text: strings["MOI_ERROR_UNSUPPORTED_TAG_MSG"],
				key: 'moi_error_unsupported_tag',
				show_in_modal: false,
				ctas: ["redirect_to_activation_method"]
			}
		};
	}
});



export default Globals;
